module.exports = __webpack_public_path__ + "assets/pencil-white-7939a7.svg";